import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
// import { Modal, Button } from "@material-ui/core";
import Card from "@mui/material/Card";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as UploadIcon } from "../../../myfin_v2/assets/icons/upload.svg";
import Modal from "../../../myfin_v2/elements/Modal";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as ExcelIcon } from "../../../myfin_v2/assets/icons/excel.svg";
import { ReqFieldLabel } from "../../../myfin_v2/components/mis";

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  backgroundColor: "#F8F8F8",
  border: "none",
  borderRadius: 2,
  p: 2,
};
const units = ["Whole Numbers", "Hundreds", "Thousands", "Lakhs", "Crores"];

const SelectColumn = ({
  isSelectColumnModal,
  tbHeaders,
  headersMappedData,
  onChangeTB,
  TBModalCleanUp,
  SetTbHeaders,
  CoaName,
  setIsSelectColumnModal,
}) => {
  return (
    <>
      {isSelectColumnModal && (
        <Modal
          width="40%"
          title="Map Column headers"
          bodycss={commoncss.unsetPadding}
          headerActions={
            <CloseIcon
              onClick={() => {
                setIsSelectColumnModal(false);
              }}
              className="clickable"
            />
          }
          onClose={TBModalCleanUp}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={() => {
                  setIsSelectColumnModal(false);
                }}
                label="Cancel"
              />
              <Button
                btnColor={buttoncss.primary}
                label="Proceed"
                onClick={SetTbHeaders}
              />
            </>
          }
        >
          <div className="container">
            <div className="row mb-3 mt-3">
              <div className="col-md-6">
                <span className="input-label">
                  <ReqFieldLabel />
                  &nbsp;Ledger code
                </span>
                <SelectMenu
                  key={"ledgerCode"}
                  data={tbHeaders}
                  name={"ledgerCode"}
                  value={headersMappedData["ledgerCode"]}
                  onChange={onChangeTB}
                />
              </div>
              <div className="col-md-6">
                <span className="input-label">
                  <ReqFieldLabel />
                  &nbsp;Ledger Name
                </span>
                <SelectMenu
                  key={"ledgerName"}
                  data={tbHeaders}
                  name={"ledgerName"}
                  value={headersMappedData["ledgerName"]}
                  onChange={onChangeTB}
                />
              </div>
            </div>
            <div className="row mb-3 mt-3">
              <div className="col-md-6">
                <span className="input-label">
                  <ReqFieldLabel />
                  &nbsp;Amount in
                </span>
                <SelectMenu
                  key={"amountIn"}
                  data={units}
                  name={"amountIn"}
                  value={headersMappedData["amountIn"]}
                  onChange={onChangeTB}
                />
              </div>
              <div className="col-md-6">
                <span className="input-label">
                  <ReqFieldLabel />
                  &nbsp;Period End Balance
                </span>
                <SelectMenu
                  key={"periodEndingBalance"}
                  data={tbHeaders}
                  name={"periodEndingBalance"}
                  value={headersMappedData["periodEndingBalance"]}
                  onChange={onChangeTB}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6">
                <span className="input-label">
                  <ReqFieldLabel />
                  &nbsp;Period Beginning Balance
                </span>
                <SelectMenu
                  key={"periodBeginingBalance"}
                  data={tbHeaders}
                  name={"periodBeginingBalance"}
                  value={headersMappedData["periodBeginingBalance"]}
                  onChange={onChangeTB}
                />
              </div>
              <div className="col-md-6">
                <span className="input-label">
                  <ReqFieldLabel />
                  &nbsp;Import Mapping from
                </span>

                {/* <TextField className="w-100" id="outlined-basic" variant="outlined" /> */}
                <SelectMenu
                  key={"bookClosureCOAID"}
                  data={CoaName}
                  name={"bookClosureCOAID"}
                  value={headersMappedData["bookClosureCOAID"]}
                  onChange={onChangeTB}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SelectColumn;

const SelectMenu = ({ data, name, value, onChange }) => {
  console.log("data",data);
  console.log(" name", name)
  console.log("value",value)
  console.log("onChange",onChange)
  return (
    <>
      <Select
        labelId="demo-simple-select-standard-label"
        id="demo-simple-select-standard"
        className="w-100"
        name={name}
        value={value}
        onChange={onChange}
        displayEmpty
        sx={{
          backgroundColor: "#f4faf5",
          border: "1px solid #c2e6d1",
          borderRadius: "10px",
          color: "#4d6d64",
          "& .MuiSelect-select": {
            padding: "8px 10px",
            color: "#4d6d64",
          },
          "& .MuiSelect-icon": {
            color: "#4d6d64",
          },
          "& fieldset": {
            border: "none",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#f4faf5",
            },
          },
        }}
      >
        <MenuItem value={"select"} disabled sx={{ color: "#4d6d64" }}>
          {`Select ${name}`}
        </MenuItem>
        {data &&
          data.length > 0 &&
          data.map((ele, ix) => (
            <MenuItem key={ix} value={ele} sx={{ color: "#4d6d64" }}>
              {ele}
            </MenuItem>
          ))}
      </Select>
    </>
  );
};
